import "/src/scss/autoload.scss";
import scrollRecognition from "./js/scrollrecognition";
import menu from "./js/menu.mjs";
import scrollUp from "./js/scrollup.js";
import domready from "./js/domready.js";
import "./scss/svg/svg.js";
// import popupPdf from "./js/popup.js";

domready(async () => {
    console.log("DOMContentLoaded");
    menu?.toggle();
    console.log(document.querySelectorAll(".swiper"));
    scrollRecognition();
    try {
        menu?.tooltip();
    } catch (e) {
        console.log(e);
    }
    try {
        scrollUp("wrapper");
    } catch (e) {
        console.log(e);
    }

    // const popup = await import("./js/popup.js");
    // console.log({ popup });
    // popup.default();

    const accordions = document.querySelectorAll(".accordion");
    if (accordions.length) {
        // await import("./acfe/accordion");
    }

    // const swiper = document.querySelectorAll(".swiper");
    // console.log(swiper);
    // if (swiper.length) {
    //   console.log("swiper found");
    //   await import("./acfe/cards.js");
    // }

    await import("./js/a11y.js");
});
